import type { ReactNode } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';
import type { SeoLinkItem } from '@alltrails/types/SeoLinkItem';
import styles from './LinkSection.module.scss';

type LinkSectionProps = {
  heading: string;
  links: SeoLinkItem[];
  showMoreToggle?: ReactNode;
};

const LinkSection = ({ heading, links, showMoreToggle }: LinkSectionProps) => {
  const linksHalfListLength = Math.ceil(links.length / 2);
  const [firstColumnLinks, secondColumnLinks] = [links.slice(0, linksHalfListLength), links.slice(linksHalfListLength, links.length)];

  return (
    <div className={styles.container}>
      <Typography variant="heading200" component="div" className={styles.header}>
        {heading}
      </Typography>
      <div className={styles.columnedSection}>
        <ul className={styles.linksColumn}>
          {firstColumnLinks.map(link => (
            <li key={link.url} className={styles.listItem}>
              <Link href={link.url} size="sm" variant="secondary" noUnderline>
                {link.title}
              </Link>
            </li>
          ))}
        </ul>
        <ul className={styles.linksColumn}>
          {secondColumnLinks.map(link => (
            <li key={link.url} className={styles.listItem}>
              <Link href={link.url} size="sm" variant="secondary" noUnderline>
                {link.title}
              </Link>
            </li>
          ))}
          {showMoreToggle && (
            <li className={styles.listItem} key="seo-links-show-more-toggle">
              {showMoreToggle}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default LinkSection;
